import React from 'react'
import PropTypes from 'prop-types'

import './style.scss'
import { HHTextField } from 'components/form-fields/v5'
import { classNames } from 'utils/styling'

const CommonTextfield = ({
  id,
  type,
  name,
  rows,
  value,
  variant,
  onChange,
  onFocus,
  onBlur,
  tabIndex,
  disabled,
  readonly,
  required,
  autoFocus,
  fullWidth,
  className,
  multiline,
  onKeyPress,
  placeholder,
  defaultValue,
  refVar,
  startAdornment,
  withClasses = true,
  ...rest
}) => {
  if (value && defaultValue) {
    // console will not crash the app, using throw error method will crash it
    console.error('Value & default value cannot present together')
  }

  return (
    <div className={classNames([withClasses && `common textfield`, className])}>
      <HHTextField
        inputRef={refVar}
        autoComplete="off"
        InputProps={{
          'aria-label': name,
          tabIndex,
          startAdornment,
        }}
        id={id}
        rows={rows}
        name={name}
        type={type}
        value={value}
        disabled={disabled}
        readonly={readonly}
        variant={variant}
        required={required}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        multiline={multiline}
        autoFocus={autoFocus}
        fullWidth={fullWidth}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        defaultValue={defaultValue}
        {...rest}
      />
    </div>
  )
}

CommonTextfield.defaultProps = {
  rows: 2,
  id: null,
  name: null,
  value: null,
  type: 'text',
  tabIndex: '',
  className: '',
  required: null,
  autoFocus: null,
  disabled: false,
  readonly: false,
  onKeyPress: null,
  fullWidth: false,
  multiline: false,
  placeholder: null,
  defaultValue: null,
  variant: 'standard',
  onFocus: null,
  onBlur: null,
  refVar: null,
  startAdornment: null,
}

CommonTextfield.propTypes = {
  refVar: PropTypes.any,
  id: PropTypes.string,
  type: PropTypes.string,
  rows: PropTypes.number,
  name: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  multiline: PropTypes.bool,
  autoFocus: PropTypes.bool,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  onKeyPress: PropTypes.func,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  startAdornment: PropTypes.any,
  withClasses: PropTypes.bool,
}

export default CommonTextfield
